import type { FC, ReactNode } from 'react'
import classNames from 'classnames'

import styles from './ChatMessage.module.scss'

interface MessageBubbleProps {
  children: ReactNode
  sender: 'agent' | 'user'
}

export const MessageBubble: FC<MessageBubbleProps> = ({ children, sender }) => {
  const containerClass =
    sender === 'agent' ? styles.agentMessage : styles.userMessage
  const bubbleClass =
    sender === 'agent' ? styles.agentBubble : styles.userBubble

  return (
    <div className={classNames(styles.messageContainer, containerClass)}>
      <div className={classNames(styles.messageBubble, bubbleClass)}>
        <div className={styles.messageContent}>{children}</div>
      </div>
    </div>
  )
}

export default MessageBubble
